import { displayNumber } from 'utils/misc';

type Props = {
  value: number;
};
export default function MonetaryDisplay(props: Props) {
  return (
    <div>
      <div style={{ float: 'left', paddingLeft: '2rem' }}>€</div>
      <div style={{ float: 'right' }}>{displayNumber(props.value, 2)}</div>
    </div>
  );
}
